import React from "react"
import {useTranslation} from "react-i18next"

import {IonItem, IonItemDivider, IonItemGroup, IonLabel, IonNote} from "@ionic/react"

import PersonGroup from "../../../types/PersonGroup"

export interface componentProps {
    item: PersonGroup
}

const ViewItemGroupInfo: React.FC<componentProps> = ({item} ) => {

    const {t} = useTranslation()

    const peopleCount: number  = item !== undefined ? item.counts?.people || 0 : 0
    const lockingSystemPermissionsCount: number = item !== undefined ? item.counts?.lockingSystemPermissions || 0 : 0

    return (
        <IonItemGroup>
            <IonItemDivider>{t('common.linked')}</IonItemDivider>
            <IonItem lines="full" button={peopleCount > 0} detail={peopleCount > 0}
                     routerLink={'/person-groups/' + item.id + '/people'}
                >
                <IonLabel>{t('people.title_list')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">{peopleCount || '-'}</IonNote>
            </IonItem>
            <IonItem lines="full" button={lockingSystemPermissionsCount > 0} detail={lockingSystemPermissionsCount > 0}
                     routerLink={'/person-groups/' + item.id + '/locking-system-permissions'}
                >
                <IonLabel>{t('locking-system-permissions.title_list')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">{lockingSystemPermissionsCount || '-'}</IonNote>
            </IonItem>
        </IonItemGroup>
    )
}

export default ViewItemGroupInfo